import React, { useMemo } from 'react';

export function DailySum({ entries = [], totalOverride, dailyOverride }) {
  const { daily, total } = useMemo(() => {
    const now = new Date();

    // Tageswert: wenn dailyOverride vorhanden, direkt nehmen (kein entries-Scan nötig)
    let dailySum =
      typeof dailyOverride === 'number' && !Number.isNaN(dailyOverride)
        ? dailyOverride
        : 0;

    if (!(typeof dailyOverride === 'number')) {
      // Fallback, falls Server daily_collected noch nicht liefert
      for (const e of entries) {
        if (!e || e.amount == null || !e.timestamp) continue;
        const dt = new Date(e.timestamp);
        if (
          dt.getFullYear() === now.getFullYear() &&
          dt.getMonth() === now.getMonth() &&
          dt.getDate() === now.getDate()
        ) {
          dailySum += parseFloat(e.amount) || 0;
        }
      }
    }

    // Gesamtsumme: bevorzugt totalOverride (aus user_totals)
    const overallSum =
      typeof totalOverride === 'number' && !Number.isNaN(totalOverride)
        ? totalOverride
        : entries.reduce((acc, e) => acc + (parseFloat(e?.amount) || 0), 0);

    return { daily: dailySum, total: overallSum };
  }, [entries, totalOverride, dailyOverride]);

  return (
    <div className="pfp-daily-sum">
      <h2>
        {daily.toFixed(2).replace('.', ',')} € <small style={{ color: '#777' }}>heute</small>
      </h2>
      <div>
        Gesamt: {total.toFixed(2).replace('.', ',')} €
      </div>
    </div>
  );
}
